export class CarouselConsultantModule {
    
    constructor() {
        if ($("#component-consultant-carousel").length > 0) {
            this.properties();
            this.init(); 
        }              
    }

    properties() {
        this.sliderSelector = "#component-consultant-carousel .consultant-carousel__slider";
        this.sliderItemSelector = "#component-consultant-carousel .consultant-carousel__item";
        this.initialSlide = 0;
        this.consultants = [];
        this.nodeId = $("body").data("content");
        this.hospitalId = $("body").data("hospital-id");
        this.treatmentId = $("body").data("treatment-id");
        this.documentType = $("body").data("dtype");
        this.contentId = $("body").data("content");
        this.consultantsRepoItems = `consultantsRepoItems${this.contentId}`;
        this.consultantsRepoDate = `consultantsRepoDate${this.contentId}`;
        this.refreshTimeInMinutes = 5;
        this.usePicker = $("span.consultantpicker").data("usepicker");
        this.hidePractisingAt = $("span.consultantpicker").data("hidepractisingat");
        this.disableLocalStorage = false;
        
    }

    hasLocalStorage() {
        if (this.disableLocalStorage) return false;
        if (typeof(Storage) === "undefined") return false;
        if (window.localStorage === "undefined") return false;
        return true;
    }

    loadLocal() {
       this.getConsultantsRepoLocalStorage();
    }
    //
    loadRemote() {
        let _this = this;
        
        $(this.sliderItemSelector).slick('slickRemove');
        var c_baseUrl = apilocation + "consultantapi/GetConsultantsForCarousel";

        

        let data = {
            hospitalid: this.hospitalId
        };

        if (this.treatmentId !== 0) {
            data = {
                hospitalid: this.hospitalId,
                treatmentid: this.treatmentId
            }
        } else if (this.treatmentId === 0 && this.contentId > 0 && this.documentType === "hospitaltreatmentarea") {
            c_baseUrl = apilocation + "consultantapi/GetHospitalConsultantsForCarouselByTreatmentArea";
            data = {
                hospitalid: this.hospitalId,
                treatmentAreaId: this.contentId
            }
        }

        if (this.usePicker) {
            c_baseUrl = apilocation + "consultantapi/GetPickedConsultantsForCarousel";
            data = {
                nodeid: this.nodeId,
                hospitalid: this.hospitalId
            }

        }

        $.ajax({
            type: 'get',
            data: data,
            url: c_baseUrl,
            dataType: "json",
            success: function( response ) {
                let consultants = response;
                if (consultants.length > 0) {
                    _this.saveConsultantsRepoDateLocalStorage();
                    _this.saveConsultantsRepoLocalStorage(consultants);
                    _this.loadHandleBars(consultants);
                }
                else {
                    $("#component-consultant-carousel").hide();
                }
                                      
            }
        });
    }

    saveConsultantsRepoLocalStorage(consultants) {
        if (this.hasLocalStorage()) {
            localStorage.setItem(this.consultantsRepoItems, JSON.stringify(consultants)); 
        } 
    }

    saveConsultantsRepoDateLocalStorage() {
        if (this.hasLocalStorage()) {
            localStorage.setItem(this.consultantsRepoDate, this.getCurrentIsoDate());
        } 
    }

    getConsultantsRepoLocalStorage() {
        if (this.hasLocalStorage()) {
            let consultants = localStorage.getItem(this.consultantsRepoItems);
            var json = JSON.parse(consultants);
            console.log("*** getting data from local storage")
            this.loadHandleBars(json);
        } 
    }

    getConsultantsRepoDateLocalStorage() {
        if (this.hasLocalStorage()) {
            localStorage.getItem(this.consultantsRepoDate);
        } 
    }

    getCurrentIsoDate() {
        var now = new Date();
        return new Date(now).toISOString();
    }

    addMinutes(date, minutes) {
        return new Date(date.getTime() + minutes*60000);
    }

    validDateToUseLocalRepo() {
        if (this.hasLocalStorage()) {
            if (localStorage.getItem(this.consultantsRepoDate) === null) return false;
            let consultantsRepoDate = localStorage.getItem(this.consultantsRepoDate);
            let saveConsultantsRepoDate = new Date(consultantsRepoDate);
            let expirationDate = this.addMinutes(saveConsultantsRepoDate, this.refreshTimeInMinutes);
            if (new Date() > expirationDate){
            } else {
                return true;
            }
        }

        return false;
    }

    addImageLiquid() {
        $('.consultant-carousel__image').imgLiquid({
            horizontalAlign: '74%'
        });
    }
    
    removeOldLocaleStorage() {

        let _this = this;
        function allStorage() {

            let archive = [],
                keys = Object.keys(localStorage),
                i = 0, key;
        
            for (; key = keys[i]; i++) {
                archive.push(key);
            }
        
            return archive;
        }
        
        let keys = allStorage();
        
        keys.forEach(function(key) {
            
            if (key) {
                let hasItems = key.indexOf("consultantsRepoItems") !== -1;
                let isToday = false;     
                let currentConsultant = key.indexOf(_this.contentId) !== -1;            
                if (hasItems && !currentConsultant) {               
                    let consultantsRepoDateKey = key.replace("consultantsRepoItems", "consultantsRepoDate");
                    let repoDateValue = localStorage.getItem(consultantsRepoDateKey);
                    let repoDate = new Date(repoDateValue);                    
                    let formattedDate = _this.formatDate(repoDate);			
                    let currentDate = _this.formatDate(new Date());                    
                    if (formattedDate === currentDate) isToday = true;
                    if (!isToday) {
                        localStorage.removeItem(key);                    
                        localStorage.removeItem(consultantsRepoDateKey);
                    }
                }  
            }
            
        });
        
    }

    formatDate(date) {
        
        let dd = date.getDate();
        let mm = date.getMonth() + 1; //January is 0!        
        let yyyy = date.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        } 
        if (mm < 10) {
          mm = '0' + mm;
        } 
        let output = dd + '/' + mm + '/' + yyyy;        
        return output;        
    }

    loadSlick() {

        let _this = this;
        $(this.sliderSelector).slick({
            slidesToScroll: 1.1,
            slidesToShow: 1,
            initialSlide: 0,
            arrows: false,
            dots: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 300,            
                    settings: {
                        dots: false,
                        infinite: false,
                        slidesToShow: 1.1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                },
                {
                    breakpoint: 767,            
                    settings: {
                        dots: false,
                        infinite: false,
                        slidesToShow: 2.2,
                        slidesToScroll: 2,
                        arrows: false
                    }
                },
                {
                    breakpoint: 1024,            
                    settings: {
                        dots: false,
                        infinite: false,
                        slidesToShow: 3.2,
                        slidesToScroll: 3,
                        arrows: true
                    }
                },
                {
                    breakpoint: 1100,            
                    settings: {
                        dots: false,
                        infinite: false,
                        slidesToShow: 3.2,
                        slidesToScroll: 1,
                        arrows: true
                    }
                }
            ]
        });      

        $(this.sliderSelector).on('afterChange', function(){
            _this.addOpacity();
        });

        _this.addOpacity();
    }

    addOpacity() {

        $(".consultant-carousel__item").removeClass("consultant-carousel__opacity");
        let index = 0;
        $(".consultant-carousel__item.slick-active").each(function(){

            if (index === 2) {
                $(this).addClass("consultant-carousel__opacity");
            }              

            index++;
        });
    }

    loadHandleBars(consultants)  {

        if (consultants === null || consultants.length === 0) {
            $("#component-consultant-carousel").hide();
            return;
        }

        // check for hideAvailability flag from hidden flag in markup.
        const hideAvailability = $("#hideAvailability").val();
        if (hideAvailability == "true") {
            consultants.forEach((element => {
                element.HideAvailability = (hideAvailability === 'true' || hideAvailability === 'True');
            }));
        }

        let source = $("#consultant-template").html(),
        template,
        context,
        html;

        if(source) {
            template = Handlebars.compile(source);
            context = {consultants: consultants, hidePractisingAt: this.hidePractisingAt};
            html    = template(context);				
            $("#consultant-template").after(html);
        }

        let _this = this;
        setTimeout(function () {
            if (consultants === null || consultants.length === 0) {
                $("#component-consultant-carousel").hide();
                return;
            }

            $('#component-consultant-carousel').show();
            _this.loadSlick();
            _this.addImageLiquid();
            _this.equalHeights();
            _this.bindSlickArrowClick();
        }, 
        300);
      
    }

    equalHeights() {
        $(".consultant-carousel__slider").each(function () {
            var highestBox = 0;

            $(".consultant-carousel__panel", this).each(function () {
                if ($(this).height() > highestBox) {
                    highestBox = $(this).height(); 
                }
            });

            $('.consultant-carousel__panel', this).height(highestBox);
            $('.consultant-carousel__gradient--right').show().height(highestBox + 20);
            $('.consultant-carousel__gradient--left').height(highestBox + 20);
        });
    }

    /* bind arrow click */
    bindSlickArrowClick () {
        let _this = this;     
        $(document).on('click',"#component-consultant-carousel .slick-arrow", function(){
            _this.updateGradientIfSlickIsDisabled();            
        });
    }

    updateGradientIfSlickIsDisabled () {
       
        setTimeout(() => {

            if ($("#component-consultant-carousel .slick-prev").hasClass('slick-disabled')) {
                $("#component-consultant-carousel .consultant-carousel__gradient--left").fadeOut();
            } else {
                $("#component-consultant-carousel .consultant-carousel__gradient--left").fadeIn();
            }

            if ($("#component-consultant-carousel .slick-next").hasClass('slick-disabled')) {
                $("#component-consultant-carousel .consultant-carousel__gradient--right").fadeOut();
            } else {
                $("#component-consultant-carousel .consultant-carousel__gradient--right").fadeIn();
            }

            }, 200);
    }

    init() {
        let validDateToUseLocalRepo = this.validDateToUseLocalRepo();
        if (validDateToUseLocalRepo) {
            this.loadLocal();  
        } else {
            this.loadRemote();  
        }
        
        // remove old storage items
        if (this.hasLocalStorage()) {
            this.removeOldLocaleStorage();
        }
    }
}
  
    




